<script setup>
import ContactForm from '~/components/forms/generics/ContactForm.vue'
import HTitle from '~/components/seo/HTitle.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const loading = ref(false)

const blockContent = computed(() => props.data.content)
const haveVSpacing = computed(() => blockContent.value.vSpacing)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'mt-3': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})

</script>

<template>
  <div v-if="blockContent"
       class="grid grid-cols-12 !mb-0 buy-index bg-[#fcfbfa]"
       :class="containerClasses">
    <div class="col-span-12 lg:col-span-8 lg:col-start-3 lg:py-8 text-[#363330]">
      <div class="grid grid-cols-12 gap-8">
        <div class="col-span-12 bg-white px-4">
          <ContactForm/>
        </div>
      </div>
    </div>
    <!--
    <div class="col-span-12 sm:col-span-6 p-8 text-[#363330]">
      <HTitle v-if="blockContent.title" :type="blockContent.titleH" class="text-center mb-3 mx-4 lg:mx-0 !text-red-800">
        {{ blockContent.title }}
      </HTitle>
      <div v-html="blockContent.description" class="mb-4 text-center"></div>
    </div>
    -->
  </div>
</template>
